













import Vue from 'vue';
import * as api from '@/api';

interface MenuItem {
    id: string;
    name: string;
    icon: string;
    path: string;
    count?: number;
}

export default Vue.extend({
    name: 'UserMenu',
    computed: {
        summary(): api.UserSummary {
            return this.$store.state.userSummary;
        },
        unreadCount(): number {
            return this.$store.state.unreadCount;
        },
    },
    data() {
        return {
            menu: [
                {
                    id: '1',
                    name: '我的收藏',
                    icon: 'iconheart-selected',
                    path: '/user/collect',
                },
                {
                    id: '2',
                    name: '待更新',
                    icon: 'iconicon_gengxin',
                    path: '/user/tobeUpdate',
                    count: 0,
                },
                {
                    id: '3',
                    name: '已下载',
                    icon: 'iconicon_xiazai',
                    path: '/user/downloaded',
                },
                {
                    id: '4',
                    name: '品牌',
                    icon: 'iconicon_pinpai',
                    path: '/user/brand',
                },
                {
                    id: '5',
                    name: '消息',
                    icon: 'iconicon_xiaoxi',
                    path: '/user/news',
                    count: 0,
                },
                {
                    id: '6',
                    name: '个人信息',
                    icon: 'iconicon_shezhi',
                    path: '/user/userinfo',
                },
            ] as MenuItem[],
        };
    },
    watch: {
        summary: {
            handler(val: api.UserSummary) {
                this.menu[1].count = val.toBeUpdatedCount;
            },
            deep: true,
        },
        unreadCount: {
            handler(val: number) {
                this.menu[4].count = val;
            },
            immediate: true,
        },
    },
    methods: {
},
});
